import { addMonths, format, getDay, getDaysInMonth, startOfMonth, subMonths } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from 'react-icons/md';
import './DateScroll.scss';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useLocation } from 'react-router';

export function getDayName(dateStr, locale) {
  var date = new Date(dateStr);
  return date.toLocaleDateString(locale, { weekday: 'short' });
}

export const getSlashDate = (d) => {
  const allDaysInMonth = getDaysInMonth(d);
  const activeDate = format(d, 'yyyy MMM');
  const dateArr = activeDate.split(' ');
  const activeYear = dateArr[0];
  const activeMonth = dateArr[1]?.toLowerCase();

  return {
    allDaysInMonth,
    activeDate,
    dateArr,
    activeYear,
    activeMonth
  };
};

// =========== activeMonths ===========

export const activeMonths = (selDate) => {
  let nextMonth = addMonths(selDate, 1);
  const currentDateInfo = getSlashDate(selDate);
  const nextDateInfo = getSlashDate(nextMonth);

  const currentMonthArray = [...Array(currentDateInfo.allDaysInMonth)].map((elementInArray, index) => {
    const newArrayData = {
      day: index + 1,
      month: currentDateInfo.activeMonth,
      year: currentDateInfo.activeYear
    };
    return newArrayData;
  });
  const nextMonthArray = [...Array(nextDateInfo.allDaysInMonth)].map((elementInArray, index) => {
    const newArrayData = {
      day: index + 1,
      month: nextDateInfo.activeMonth,
      year: nextDateInfo.activeYear
    };
    return newArrayData;
  });
  return [...currentMonthArray, ...nextMonthArray];
  // const blankDays = nextMonthArray.slice(0, firstDayOfMonth);
};

const DateScroll = (props) => {
  const location = useLocation();
  const [selectedDate, setSelectedDate] = useState(null);

  // const [currentMonthArrays, setCurrentMonthArrays] = useState([]);
  const [activeMonthArrays, setActiveMonthArrays] = useState([]);
  const [dateTable, setDateTable] = useState(false);
  // const [currentMonthArrays, setCurrentMonthArrays] = useState([]);
  // const [activeMonthArrays, setActiveMonthArrays] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeMonthCount, setActiveMonthCount] = useState(getDaysInMonth(new Date()));
  const [selectedDateChange, setSelectedDateChange] = useState('');
  const [showCalander, setShowCalander] = useState(false);
  useEffect(() => {
    setDate();
  }, []);

  useEffect(()=>{
    if(props.dateBySelect){
      setDate(props.dateBySelect);
    }
  },[props.dateBySelect])

  useEffect(() => {
    // setTimeout(() => {
    if (location.state !== null) {
      setSelectedDateChange(location.state?.date);
      setSelectedDate(new Date(location?.state?.date).toString());
    }
    // }, 000);
  }, [location]);

  const setDate = (newDate) => {
    setSelectedDateChange(newDate);
    const date = newDate || new Date();
    props.selectedDate(date);
    let pp = date.toString();
    setSelectedDate(pp);

    // setSelectedDate(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
  };

  const getPreviousDate = () => {
    const currentDayInMilli = new Date(selectedDate).getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    const previousDayInMilli = currentDayInMilli - oneDay;
    const previousDate = new Date(previousDayInMilli);
    setDate(previousDate);
  };

  const getNextDate = () => {
    const currentDayInMilli = new Date(selectedDate).getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    const nextDayInMilli = currentDayInMilli + oneDay;
    const nextDate = new Date(nextDayInMilli);
    setDate(nextDate);
  };

  return (
    <div
      className="date_scroll_container d-flex align-items-center pb-2"
      onMouseLeave={() => {
        setDateTable(false);
        setShowCalander(false);
      }}
      onMouseEnter={() => {
        setShowCalander(true);
        setDateTable(true);
      }}
    >
      <div onClick={getPreviousDate}>
        <MdOutlineArrowBackIosNew className="ne_arrow" onClick={getPreviousDate} />
      </div>
      <button onClick={() => setDate(new Date())} className="date_scroll_btn mx-3">
        <span className="date_scroll_btn_visible d-flex justify-content-center align-items-center">
          {`${selectedDate?.substring(0, 3)} ${selectedDate?.substring(3, 15)}`}
        </span>
        <span className="date_scroll_btn_invisible d-flex justify-content-center align-items-center">Go to Today</span>
      </button>

      <div onClick={() => getNextDate()}>
        <MdOutlineArrowForwardIos className="arr_right " />
      </div>
      {dateTable ? (
        <div className="date_scroll_calendar">
          {showCalander ? (
            <Calendar
              onChange={(value, event) => {
                setDate(value);
                setShowCalander(false);
              }}
              value={selectedDateChange}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default DateScroll;
